import React from 'react';
import AdminIcon from 'src/components/10-atoms/icons/AdminIcon';
import { createTabScreen } from 'src/navigation/primaryNav/createTabScreen';
import { RootTab } from 'src/navigation/TabNavigation';
import withSuspense from 'src/navigation/withSuspense';
const Home = withSuspense(React.lazy(() => import('./screens/Home')));
export const adminNavEntry = {
    id: 'admin',
    prefix: 'Admin_',
    to: { screen: 'Admin_Home', params: {} },
    label: ({ translate }) => translate('Admin'),
    renderIcon: (color, size) => React.createElement(AdminIcon, { color: color, size: size }),
    isVisible: ({ isSuperAdmin }) => isSuperAdmin,
    placements: ['tab', 'sidebar-main'],
    renderTabRoutes(ctx) {
        return (React.createElement(RootTab.Group, null, createTabScreen(adminNavEntry, ctx, 'Admin_Home', Home)));
    },
};
export function renderAdminTabRoutes(ctx) {
    return adminNavEntry.renderTabRoutes(ctx);
}
